import React, { useState } from 'react'
import { InputGroup } from 'react-bootstrap'
import SideBar from '../../components/sidebar/Sidebar'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { toast } from 'react-hot-toast'
import { FaCross } from 'react-icons/fa'
import { UpdatePassword } from './hook';
import UserLoginData from '../Auth/UserLoginData';
import { BsEyeFill, BsEyeSlashFill } from 'react-icons/bs';
import { FiShield, FiUser } from 'react-icons/fi';

const ProfileScreen = () => {

    const [currentPassword, setCurrentPassword] = useState("")
    const [newPassword, setNewPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")

    const { doChangePassword } = UpdatePassword();

    const { isLoggedIn } = UserLoginData()


    const handleSubmit = () => {
        if (newPassword === confirmPassword) {
            doChangePassword({
                currentPassword,
                newPassword,
                username: isLoggedIn.response.username
            })
        } else {
            toast("Passwords does not match", {
                duration: 2000,
                icon: <FaCross />,
                style: {
                    backgroundColor: "#ffabcd",
                    fontSize: 14,
                },
            });
        }
    }

    const [viewCurrentPassword, setViewCurrentPassword] = useState(false)
    const [viewPassword, setViewPassword] = useState(false)
    const [viewConfirmPassword, setViewConfirmPassword] = useState(false)



    return (

        <SideBar>
            <div className="create-page profile-page">
                <header className="create-page-header profile-page-header">
                    <span className="create-page-icon" aria-hidden="true"><FiUser /></span>
                    <div>
                        <h1>Profile</h1>
                        <p>Manage your account security.</p>
                    </div>
                </header>

                <section className="profile-security" aria-labelledby="profile-security-title">
                    <div className="profile-section-heading">
                        <span className="profile-section-icon" aria-hidden="true"><FiShield /></span>
                        <div>
                            <h2 id="profile-security-title">Security &amp; authentication</h2>
                            <p>Keep your account protected with a strong password.</p>
                        </div>
                    </div>

                    <div className="profile-password-section">
                        <h3>Change password</h3>
                        <p className="profile-password-note">You will be required to log in again after changing your password.</p>

                        <Form className="profile-form">
                            <Form.Group className="profile-field">
                                <Form.Label htmlFor="current-password">Current password</Form.Label>
                                <InputGroup className="profile-password-control">
                                    <Form.Control id="current-password" autoComplete="current-password" type={viewCurrentPassword ? "text" : "password"} onChange={(e) => { setCurrentPassword(e.target.value) }} />
                                    <Button variant="light" className="profile-password-toggle" type="button" aria-label={viewCurrentPassword ? "Hide current password" : "Show current password"} aria-pressed={viewCurrentPassword} onClick={() => { setViewCurrentPassword(!viewCurrentPassword) }}>{viewCurrentPassword ? <BsEyeFill /> : <BsEyeSlashFill />}</Button>
                                </InputGroup>
                            </Form.Group>
                            <Form.Group className="profile-field">
                                <Form.Label htmlFor="new-password">New password</Form.Label>
                                <InputGroup className="profile-password-control">
                                    <Form.Control id="new-password" autoComplete="new-password" type={viewPassword ? "text" : "password"} onChange={(e) => { setNewPassword(e.target.value) }} />
                                    <Button variant="light" className="profile-password-toggle" type="button" aria-label={viewPassword ? "Hide new password" : "Show new password"} aria-pressed={viewPassword} onClick={() => { setViewPassword(!viewPassword) }}>{viewPassword ? <BsEyeFill /> : <BsEyeSlashFill />}</Button>
                                </InputGroup>
                            </Form.Group>
                            <Form.Group className="profile-field">
                                <Form.Label htmlFor="confirm-password">Confirm new password</Form.Label>
                                <InputGroup className="profile-password-control">
                                    <Form.Control id="confirm-password" autoComplete="new-password" type={viewConfirmPassword ? "text" : "password"} onChange={(e) => { setConfirmPassword(e.target.value) }} />
                                    <Button variant="light" className="profile-password-toggle" type="button" aria-label={viewConfirmPassword ? "Hide confirmed password" : "Show confirmed password"} aria-pressed={viewConfirmPassword} onClick={() => { setViewConfirmPassword(!viewConfirmPassword) }}>{viewConfirmPassword ? <BsEyeFill /> : <BsEyeSlashFill />}</Button>
                                </InputGroup>
                            </Form.Group>
                            <div className="profile-form-actions">
                                <Button className="profile-submit" type="button" onClick={handleSubmit}>Update password</Button>
                            </div>
                        </Form>
                    </div>
                </section>
            </div>
        </SideBar>


    )
}

export default ProfileScreen